import { render, staticRenderFns } from "./query-expansions.vue?vue&type=template&id=cadb182e&scoped=true&"
import script from "./query-expansions.vue?vue&type=script&lang=js&"
export * from "./query-expansions.vue?vue&type=script&lang=js&"
import style0 from "./query-expansions.vue?vue&type=style&index=0&id=cadb182e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadb182e",
  null
  
)

export default component.exports